import React from "react";
import { List, Card, Modal } from "antd";

import NoteModal from "./noteModal";
import { Observer, observer } from "mobx-react";
import Item from "./item";

class Premiums extends React.Component {
  openEditModal = (premium) => {
    this.modal = Modal.info({
      title: "Edit premium product note",
      closable: true,
      footer: null,
      maskClosable: true,
      content: (
        <NoteModal
          visible
          contactId={this.props.contactId}
          premiumPurchaseId={premium.id}
          premiumPurchaseNote={premium.note}
          onChange={this.props.onChange}
          onClose={() => this.modal.destroy()}
        />
      ),
    });
  };

  componentWillUnmount() {
    this.modal?.destroy();
  }

  render() {
    const { premiumPurchases, soldPremiumPurchases } = this.props;

    return (
      <Card
        title={`PremiumsProducts(${premiumPurchases.length}￫${soldPremiumPurchases.length})`}
        style={{ width: "100vw" }}
      >
        <List
          style={{ maxHeight: "60vh", overflowY: "scroll" }}
          dataSource={premiumPurchases}
          renderItem={(item) => (
            <Observer key={item.id}>
              {() => (
                <Item
                  key={item.id}
                  {...item}
                  onClick={() => this.openEditModal(item)}
                />
              )}
            </Observer>
          )}
        />
      </Card>
    );
  }
}

export default observer(Premiums);
